// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  CanonicalAddress,
} from "./types";


export default __t.row({
  underwritableEntity: __t.uuid().name("underwritable_entity"),
  brandV1: __t.uuid().name("brand_v_1"),
  brandFriendlyName: __t.option(__t.string()).name("brand_friendly_name"),
  brandHeroCdnPath: __t.option(__t.string()).name("brand_hero_cdn_path"),
  brandColorPrimary: __t.option(__t.string()).name("brand_color_primary"),
  brandBusinessCategory: __t.option(__t.string()).name("brand_business_category"),
  brandBusinessType: __t.option(__t.string()).name("brand_business_type"),
  get brandBusinessAddress() {
    return __t.option(CanonicalAddress).name("brand_business_address");
  },
  get targetedPropertyAddress() {
    return __t.option(CanonicalAddress).name("targeted_property_address");
  },
  targetedPropertyPhotoName: __t.option(__t.string()).name("targeted_property_photo_name"),
});
